// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"301":"8473ab07","354":"f8c971d7","453":"26665d3b"}[chunkId] + ".chunk.js";
};